import { render } from "./TakePhoto.vue?vue&type=template&id=78828c00&scoped=true"
import script from "./TakePhoto.vue?vue&type=script&lang=js"
export * from "./TakePhoto.vue?vue&type=script&lang=js"

import "./TakePhoto.vue?vue&type=style&index=0&id=78828c00&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78828c00"]])

export default __exports__